import gql from "graphql-tag";

export const GET_FEATURE_FLAGS = gql`
    query featureFlags {
        featureFlags
    }
`;